import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import $ from 'jquery';

function ScrollToTop({ history }) {
	useEffect(() => {
		const unlisten = history.listen(() => {
			$('html, body').animate({ scrollTop: 0 }, 'slow');
		});
		return () => {
			unlisten();
		};
	}, [history]);

	return null;
}

export default withRouter(ScrollToTop);
